export default {
  advance: 'advance',
  stop: 'stop',
};
